import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
// images
import { useLocation } from "react-router-dom";
import { Col, Container, InputGroup, Row } from "react-bootstrap";
import name from "../../../assets/images/icons/account/name.svg";
import username from "../../../assets/images/icons/account/user.svg";
import TextInput from "../../../components/formfields/InputField";
import SelectField from "../../../components/formfields/SelectField";
import { finishSetupAction } from "../actions";
import { normalizeInput } from "../../../utils/commonFunctions";
import SubmitLoader from "../../../components/SubmitLoader";
import Loader from "../../../components/loader";
import CustomButton from "../../../components/Buttons/CustomButton";

// changed the [0-9] with \d, not checked
const validationSchema = Yup.object({
  phone: Yup.string()
    .required("Phone can not be empty")
    .matches(/1?\d{10}((ext|x)\d{1,4})?/i, "Provide a valid phone number"),
  first_name: Yup.string().required("First Name can not be empty"),
  last_name: Yup.string().required("Last Name can not be empty"),
  username: Yup.string().required("Username can not be empty"),
  how_did_you_hear: Yup.string().nullable(),
});

function FinishSetup(props) {
  const { currentStep, totalSteps, getActiveStep } = props;
  const userInfo = useSelector((state) => state?.my_account?.user_info);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const initialValues = {
    username: userInfo?.username || "",
    first_name: userInfo?.first_name || "",
    last_name: userInfo?.last_name || "",
    phone: userInfo?.phone || "",
    how_did_you_hear: userInfo?.how_did_you_hear || "",
    is_subscribe: true,
  };

  const handlePhone = (e, setFieldValue) => {
    const val = normalizeInput(e.target.value);
    setFieldValue("phone", val?.replace(/\D/g, ""));
  };

  const falseHandler = () => {
    setLoader(false);
  };

  const handleSubmit = (values, actions) => {
    setLoader(true);
    dispatch(finishSetupAction(values, props, actions, falseHandler));
  };
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {!userInfo?.id ? (
        <Loader />
      ) : (
        <div className="pt-5">
          <Container>
            <Row className="justify-content-center">
              <Col md={10} lg={8} xl={6}>
                <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize validationSchema={validationSchema}>
                  {({ values, handleChange, handleBlur, errors, touched, setFieldValue }) => {
                    return (
                      <Form className="loginForm">
                        <h1 className="text-white">Create Your Account</h1>
                        <div className="accountCard">
                          <Field
                            id="username"
                            name="username"
                            component={TextInput}
                            value={values.username}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="Username*"
                            icons={username}
                            className="mb-3"
                            iconClass="fa-user"
                          />
                          <Field
                            id="first_name"
                            name="first_name"
                            component={TextInput}
                            value={values.first_name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="First Name*"
                            icons={name}
                            className="mb-3"
                            iconClass="fa-address-card"
                          />
                          <Field
                            id="last_name"
                            name="last_name"
                            component={TextInput}
                            value={values.last_name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="Last Name*"
                            icons={name}
                            className="mb-3"
                            iconClass="fa-address-card"
                          />
                          <div className="mb-3">
                            <InputGroup>
                              <Field
                                className="form-control"
                                name="phone"
                                onChange={(e) => {
                                  handlePhone(e, setFieldValue);
                                }}
                                onBlur={handleBlur}
                                value={normalizeInput(values?.phone)}
                                readOnly={false}
                                placeholder="Phone#*"
                              />
                              <InputGroup.Text>
                                <i className="fa-regular fa-fw fa-mobile" />
                              </InputGroup.Text>
                            </InputGroup>
                            {errors?.phone && touched?.phone && <p className="errorMsg mb-0">{errors.phone}</p>}
                          </div>
                          <label htmlFor="how_did_you_hear" aria-hidden className="form-label fw-bold">
                            How did you hear about us?
                          </label>

                          <Field
                            id="how_did_you_hear"
                            name="how_did_you_hear"
                            component={SelectField}
                            value={values.how_did_you_hear}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <option value="">Select</option>
                            <option value="Logan Jones">Dr. Logan Jones</option>
                            <option value="None">None</option>
                          </Field>
                        </div>
                        <div className="text-end">
                          {loader ? (
                            <button type="submit" disabled={loader} className="btn p-0 text-white text-xl fw-bold">
                              <span disabled={loader} className="d-flex align-items-center">
                                <span disabled={loader} className="mr-2">
                                  Sending...
                                </span>{" "}
                                <SubmitLoader />
                              </span>
                            </button>
                          ) : (
                            <CustomButton className="" variant="insurance" gradient type="submit">
                              Next
                            </CustomButton>
                          )}
                        </div>
                      </Form>
                    );
                  }}
                </Formik>
              </Col>
            </Row>
          </Container>

          <p className="px-4 text-white text-xl d-flex fw-bold mt-5">
            <span>
              Step {currentStep + 1} of {totalSteps + 1}
            </span>
          </p>
          <div style={{ width: getActiveStep === 1 ? "40%" : "20%" }} className="signupProgressBar" />
        </div>
      )}
    </>
  );
}

export default connect(null, { finishSetupAction })(FinishSetup);
